import { Button } from '../../../components/base/Button';

export const HeroSection = () => {
  const handleInquiry = () => {
    const contactSection = document.getElementById('licensing-inquiry');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/5aa3ac7b3ab649f5886732c32fb7b300.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 via-slate-900/80 to-slate-900/90"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <div className="inline-flex items-center bg-amber-500/20 backdrop-blur-sm border border-amber-500/30 px-6 py-2 rounded-full text-sm font-semibold mb-8">
            <i className="ri-award-line mr-2 text-amber-400"></i>
            <span className="text-amber-300">PATENTED TECHNOLOGY</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            The New Standard for
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-200">Paper Fillers</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-4 max-w-4xl mx-auto leading-relaxed font-light">
            Revolutionizing Copy, Thermal, and Label Papers with
          </p>
          <p className="text-2xl md:text-3xl text-amber-400 mb-12 font-semibold">
            1:40 CNF Synthesis Technology
          </p>
          
          <Button 
            variant="primary" 
            size="lg" 
            onClick={handleInquiry}
            className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white shadow-2xl shadow-amber-500/30 px-12 py-4 text-lg font-semibold"
          >
            <i className="ri-mail-line mr-3"></i>
            Inquire for Licensing
          </Button>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-6 py-5">
              <p className="text-3xl font-bold text-amber-400 mb-2">1:40</p>
              <p className="text-sm text-gray-300 font-medium">CNF Synthesis Ratio</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-6 py-5">
              <p className="text-3xl font-bold text-amber-400 mb-2">50%+</p>
              <p className="text-sm text-gray-300 font-medium">Pulp Cost Reduction</p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-6 py-5">
              <p className="text-3xl font-bold text-amber-400 mb-2">Global</p>
              <p className="text-sm text-gray-300 font-medium">Patent Protection</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-line text-2xl"></i>
      </div>
    </section>
  );
};
